module.exports = __webpack_public_path__ + "img/whatsapp.3357390.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/whatsapp.svg
// module id = ./assets/whatsapp.svg
// module chunks = 13